// extracted by mini-css-extract-plugin
module.exports = {"border":"Notifier_border__3db_T","Notifier":"Notifier_Notifier__2a7dZ"};